import { Link, useLocation, useParams } from 'react-router-dom';
import './FooterTagSection.css';
import { API_BASE_URL } from '../../utils';
import { useEffect, useState } from 'react';
import axios from 'axios';





export default function FooterTagSection({ clubInfo }) {

    const [clubname, city, area] = clubInfo?.split("-").map((str) => str.replace(/_/g, " ")) || [];

    
    const location = useLocation();
    
    const nameUrl = location.pathname.split("/").pop().replace(/-/g, " ") ;

    const [relatedLinks, setRelatedLinks] = useState([]);
    const handleFetchfooterTags = async () => {

        const formData = new FormData();
        formData.append(
            "slug",
            location?.pathname ? location.pathname.replace(/^\/+/, "") : ""
        );


        try {
            const response = await axios.post(`${API_BASE_URL}/master/APIs/Web/footertags`, formData);
            console.log("data", response.data.data);
            setRelatedLinks(response?.data?.data);
        } catch (error) {
            console.error("Error fetching footer tags:", error);
        }
    }

    useEffect(() => {
        handleFetchfooterTags();
    }, []);


    return (
        <>
            <div className='vcdp-FooterTagSection'>
                <div className='vcdp-FooterTagSection-container'>
                    <div className='vcdp-FooterTagSection-content-header'>
                        <h1>Related to :- {nameUrl}</h1>
                    </div>
                    <div className='vcdp-FooterTagSection-content'>
                        <p className="vcdp-FooterTagSection-content-text-tags">
                            {relatedLinks?.map((item, index) => (
                                <span key={index}>
                                    <Link
                                        to={item?.tag_url}
                                        className={item?.tag_url  ? 'vcdp-tag-link-blue' : 'vcdp-tag-link'}
                                    >
                                        {item.tag}
                                    </Link>
                                    {index !== relatedLinks?.length - 1 && ", "}
                                </span>
                            ))}
                        </p>
                    </div>
                </div>
            </div>

        </>
    )
}
